import React from "react";
import { Switch, Route } from "react-router-dom";
import Login from "./page/Login/login";
import App from "./App";
import ProtectedRoute from "./routers/protectedRoute";

const AppRoutes = () => (
  <Switch>
    <Route path="/Login" component={Login} />
    <ProtectedRoute path="/" component={App} />
  </Switch>
);

export default AppRoutes;
